import React from "react";
import ApproveSiteTask from "./ApproveSiteTask";
import ApproveChangeTask from "./ApproveChangeTask";

class SingleTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showApproveDialog: false,
        }
    }
    _onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open(this.props.site.url, '_blank');
    }

    _closeModal = () => {
        this.setState({showModal: false})
    }

    render() {
        const toRender = this.props.element.label === 'createTask' ? 
            <ApproveSiteTask
                site = {this.props.element}
                refresh = {this.props.refresh}
            /> :
            <ApproveChangeTask
                change = {this.props.element}
                refresh = {this.props.refresh}
            />
        return(
            toRender
        );
    }
}
export default SingleTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SingleTask.js